/**
 * Page Allow/Block Policy Evaluator
 *
 * Evaluates pageAllowList and pageBlockList against the current page path.
 * Patterns support exact match and prefix match (ending with *).
 * Evaluated client-side before rendering the launcher.
 */

/**
 * Returns true if the current page path is permitted by the widget policy.
 *
 * Logic (matches server-side domainPolicy middleware):
 * 1. If pageBlockList has a matching pattern → blocked
 * 2. If pageAllowList is non-empty and no pattern matches → blocked
 * 3. Otherwise → allowed
 */
export function isPageAllowed(
  path: string,
  pageAllowList: string[],
  pageBlockList: string[],
): boolean {
  if (pageBlockList.length > 0 && matchesPatternList(path, pageBlockList)) {
    return false;
  }

  if (pageAllowList.length > 0 && !matchesPatternList(path, pageAllowList)) {
    return false;
  }

  return true;
}

function matchesPatternList(path: string, patterns: string[]): boolean {
  return patterns.some((pattern) => matchesPattern(path, pattern));
}

function matchesPattern(path: string, pattern: string): boolean {
  if (pattern.endsWith("*")) {
    return path.startsWith(pattern.slice(0, -1));
  }
  return path === pattern;
}
